(function() {
    'use strict';

    angular
        .module('elogbooks.common.assets')
        .controller('UserAssetsSubAssetsController', UserAssetsSubAssetsController);

    UserAssetsSubAssetsController.$inject = ['$state', '$stateParams', 'subAssetCollectionResponse', 'assetResponse', 'config', '$translate'];

    function UserAssetsSubAssetsController($state, $stateParams, subAssetCollectionResponse, assetResponse, config, $translate) {
        var vm = this;
            vm.subAssets = subAssetCollectionResponse.subassets;
            vm.subAssetCollectionResponse = subAssetCollectionResponse;
            vm.hideAdd = $state.current.name.indexOf('jobs.list.details.sub-assets') > 0;
            vm.pages = subAssetCollectionResponse.pages;

        vm.criteria = {
            subAssetName: { type: 'text', title: 'NAME', value: $stateParams.subAssetName },
            subAssetReference: {type: 'text', title: 'REFERENCE', value: $stateParams.subAssetReference},
            subAssetActive: {
                type: 'options',
                title: 'IS_ACTIVE',
                value: $stateParams.subAssetActive,
                options: [
                    {title: $translate.instant('STATUS_ALL'), value: 'all'},
                    {title: $translate.instant('STATUS_ACTIVE'), value: '1'},
                    {title: $translate.instant('STATUS_INACTIVE'), value: '0'}
                ],
                param: 'subAssetActive'
            }
        };

        vm.config = config;
        vm.type = config.entityName ? 'view' : 'list';
        vm.title = config.entityName === 'JOB' ? assetResponse.name : null;

        vm.search = searchAction;
        vm.order = orderAction;

        function searchAction(params) {
            var override = {
                subAssetPage: 1
            };

            $state.go('.', angular.extend({}, params, override), { reload: $state.current });
        }

        function orderAction(key) {
            $stateParams.subAssetOrder = key;

            $state.go('.', angular.extend({}, $stateParams), { reload: $state.current });
        }
    }
})();
